/**
 * REVAHS Pre-order Auto-Discount - ULTRA SIMPLE
 * Intercepts ALL navigation to /checkout and adds PREORDER10
 */

(function() {
  'use strict';

  const PREORDER_CODE = 'PREORDER10';
  
  console.log('[REVAHS Preorder] Ultra Simple version initializing...');
  
  /**
   * Check if cart contains pre-order items
   */
  async function cartHasPreorderItems() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      if (!cart.items || cart.items.length === 0) {
        return false;
      }

      // Get pre-order variant IDs from page
      const preorderVariantIds = [];
      
      // From any element with data-is-preorder="true"
      document.querySelectorAll('[data-is-preorder="true"]').forEach(el => {
        const variantId = el.dataset.variantId;
        if (variantId) preorderVariantIds.push(String(variantId));
      });
      
      // Check if any cart item matches
      const hasPreorder = cart.items.some(item => 
        preorderVariantIds.includes(String(item.variant_id))
      );
      
      if (hasPreorder) {
        console.log('[REVAHS Preorder] Pre-order items detected in cart!');
      }
      
      return hasPreorder;
      
    } catch (error) {
      console.error('[REVAHS Preorder] Error:', error);
      return false;
    }
  }

  /**
   * Intercept ALL clicks that might lead to checkout
   */
  document.addEventListener('click', async function(e) {
    const target = e.target;
    const clickedElement = target.closest('a, button, input');
    
    if (!clickedElement) return;
    
    // Check if this element leads to checkout
    const href = clickedElement.href || clickedElement.getAttribute('href') || '';
    const action = clickedElement.form?.action || '';
    const name = clickedElement.name || clickedElement.getAttribute('name') || '';
    const text = clickedElement.textContent?.toLowerCase() || '';
    
    const isCheckoutElement = 
      href.includes('/checkout') ||
      href.includes('/checkouts') ||
      action.includes('/checkout') ||
      name === 'checkout' ||
      text.includes('afrekenen') ||
      text.includes('checkout') ||
      clickedElement.classList.contains('cart__checkout') ||
      clickedElement.classList.contains('checkout');
    
    if (isCheckoutElement) {
      console.log('[REVAHS Preorder] Potential checkout click detected!', clickedElement);
      
      const hasPreorder = await cartHasPreorderItems();
      
      if (hasPreorder) {
        console.log('[REVAHS Preorder] INTERCEPTING - Redirecting with discount!');
        
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Redirect to checkout with discount
        window.location.href = '/checkout?discount=' + PREORDER_CODE;
        return false;
      } else {
        console.log('[REVAHS Preorder] No pre-order items - allowing normal checkout');
      }
    }
  }, true);

  /**
   * Intercept form submissions to /checkout
   */
  document.addEventListener('submit', async function(e) {
    const form = e.target;
    const action = form.action || form.getAttribute('action') || '';
    
    if (action.includes('/checkout')) {
      console.log('[REVAHS Preorder] Form submission to checkout detected!');
      
      const hasPreorder = await cartHasPreorderItems();
      
      if (hasPreorder) {
        console.log('[REVAHS Preorder] INTERCEPTING FORM - Redirecting with discount!');
        
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        window.location.href = '/checkout?discount=' + PREORDER_CODE;
        return false;
      }
    }
  }, true);

  /**
   * Add discount notice to cart
   */
  async function addNoticeIfNeeded() {
    const hasPreorder = await cartHasPreorderItems();
    
    if (!hasPreorder) return;
    
    // Find cart container
    const container = document.querySelector('[data-cart-drawer], .cart-drawer, #CartDrawer, .cart-template, form[action*="/cart"]');
    
    if (!container) return;
    
    // Check if notice already exists
    if (container.querySelector('.revahs-preorder-notice')) return;
    
    console.log('[REVAHS Preorder] Adding notice to cart');
    
    const notice = document.createElement('div');
    notice.className = 'revahs-preorder-notice';
    
    const lang = (document.documentElement.lang || 'nl').split('-')[0];
    const translations = {
      'nl': { title: '🎉 Pre-order korting actief!', text: 'Code <strong>PREORDER10</strong> wordt automatisch toegepast' },
      'de': { title: '🎉 Vorbesteller-Rabatt aktiv!', text: 'Code <strong>PREORDER10</strong> wird automatisch angewendet' },
      'en': { title: '🎉 Pre-order discount active!', text: 'Code <strong>PREORDER10</strong> will be applied' }
    };
    const t = translations[lang] || translations['nl'];
    
    notice.innerHTML = `
      <div style="background: linear-gradient(135deg, rgba(16,24,40,.03) 0%, rgba(16,24,40,.05) 100%); border: 1px solid rgba(16,24,40,.08); border-radius: 12px; padding: 12px 16px; margin: 16px 0; text-align: center;">
        <div style="font-size: 13px; font-weight: 700; color: #020617; margin-bottom: 4px;">${t.title}</div>
        <div style="font-size: 12px; color: rgba(2,6,23,.68); line-height: 1.4;">${t.text}</div>
      </div>
    `;
    
    // Insert before first button or at end
    const firstButton = container.querySelector('button, .button, [type="submit"]');
    if (firstButton) {
      firstButton.parentNode.insertBefore(notice, firstButton);
    } else {
      container.appendChild(notice);
    }
  }

  // Monitor cart updates
  document.addEventListener('cart:updated', () => setTimeout(addNoticeIfNeeded, 300));
  document.addEventListener('product:added-to-cart', () => setTimeout(addNoticeIfNeeded, 300));
  
  // Monitor DOM changes for cart drawer
  new MutationObserver(() => setTimeout(addNoticeIfNeeded, 300)).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
  
  // Initial check
  setTimeout(addNoticeIfNeeded, 500);
  
  console.log('[REVAHS Preorder] Ultra Simple version initialized ✓');
  
})();